import type { ReactNode } from 'react';
import type React from 'react';
import { createContext, useContext } from 'react';
import type { YourRentalRenterProfileDto } from '@zg-rentals/ts-your-rental-api-client';

interface YourRentalPageContextType {
  renterProfile?: YourRentalRenterProfileDto;
}

const YourRentalPageContext = createContext<YourRentalPageContextType | undefined>(undefined);

export const useYourRentalPageContext = () => {
  const context = useContext(YourRentalPageContext);
  if (context === undefined) {
    throw new Error('useYourRentalPageContext must be used within a YourRentalPageProvider');
  }
  return context;
};

interface YourRentalPageProviderProps {
  children: ReactNode;
  renterProfile?: YourRentalRenterProfileDto;
}

export const YourRentalPageProvider: React.FC<YourRentalPageProviderProps> = ({ children, renterProfile }) => {
  const value: YourRentalPageContextType = {
    renterProfile,
  };

  return <YourRentalPageContext.Provider value={value}>{children}</YourRentalPageContext.Provider>;
};
